module.exports = "/img/background-1.62fd759d.jpg";